import { AdminDeliveryRegisterTemplate } from "../../Templates/AdminDeliveryRegisterTemplate";

export const AdminDeliveryRegister = () => {
  return <AdminDeliveryRegisterTemplate />;
};
